"use client";

import { cx } from "@/lib/tailwind-utils";

export function EmailComposerSkeleton() {
  return (
    <div className="animate-pulse rounded-lg border border-border bg-background p-3 space-y-3">
      <div className="h-3 w-40 rounded bg-background-tertiary" />
      <div className="h-8 w-2/3 mx-auto rounded-full bg-background-tertiary" />
      <div className="border-t border-border pt-3 flex justify-end gap-2 h-24 w-full bg-background-tertiary" />
    </div>
  );
}

export function EmailThreadSkeleton() {
  return (
    <div className="animate-pulse space-y-4">
      {/* Header skeleton */}
      <div className="space-y-2">
        <div className="h-6 w-3/4 rounded bg-muted" />
        <div className="h-4 w-1/3 rounded bg-muted" />
      </div>

      <div
        className={cx(
          "rounded-lg border border-border/50 p-3 space-y-4",
          "border-l-4 border-l-muted",
        )}
      >
        {/* Message header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-4 w-32 rounded bg-muted" />
            <div className="h-3 w-40 rounded bg-muted hidden sm:block" />
          </div>
          <div className="h-3 w-20 rounded bg-muted" />
        </div>

        {/* Participants */}
        <div className="space-y-1 pb-4 border-b border-border/50">
          <div className="h-3 w-48 rounded bg-muted" />
        </div>

        {/* Body content */}
        <div className="space-y-2">
          <div className="h-64 w-full rounded bg-muted" />
        </div>
      </div>
    </div>
  );
}
